import { useTranslation } from "react-i18next";
import { Checkbox, CheckboxField } from "catalyst-ui-kit/checkbox";
import { Label } from "catalyst-ui-kit/fieldset";

type Props = {
  checked: boolean;
  onChange: (send: boolean) => void;
  disabled: boolean;
  /** The tick covers several invoices (bulk confirm) rather than one. */
  plural?: boolean;
};

/**
 * The "email the customer" tick shown next to every confirm button. The caller
 * owns the state (from `useRememberedSendChoice`) because it sends the choice
 * along when it confirms.
 */
export default function SendByEmailCheckbox({
  checked,
  onChange,
  disabled,
  plural = false,
}: Props) {
  const { t } = useTranslation();

  return (
    <CheckboxField>
      <Checkbox
        color="indigo"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <Label>
        {plural
          ? t("invoice_send_to_customers", {
              defaultValue: "Email the customers",
            })
          : t("invoice_send_to_customer", {
              defaultValue: "Email the customer",
            })}
      </Label>
    </CheckboxField>
  );
}
